<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div style></div>
        <h5 class="vue-title">
          <strong>{{ $t("MANAGER") }} ＞ {{ $t(this.FormTitle) }}</strong>
        </h5>
        <div v-if="this.managerForm.userid">
          <h5 class="vue-title">
            <strong>ID : {{ this.managerForm.userid }}</strong>
          </h5>
        </div>
        <b-form class="formTextSize" @submit.prevent="submitForm">
          <b-row>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("SURNAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="sureName"
                  class="inputField"
                  v-model.trim="$v.managerForm.last_name.$model"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.managerForm.last_name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("NAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="managerName"
                  v-model.trim="$v.managerForm.first_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.managerForm.first_name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("MAILADDRESS") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="email"
                  v-model.trim="$v.managerForm.email.$model"
                  class="inputField"
                  @keypress="preventSpecialChar($event)"
                  type="text"
                  autocomplete="off"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <div>
                  <show-errors
                    :control="$v.managerForm.email"
                    :field="$t('MANDATORY')"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PHONENUMBER") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="phonenumber"
                  v-model.trim="$v.managerForm.contact_no.$model"
                  class="inputField"
                  type="tel"
                  @keypress="isNumberValidatorphone($event)"
                  autocomplete="off"
                  :maxlength="CONSTANTS.MaxPhone"
                ></b-form-input>

                <show-errors
                  :control="$v.managerForm.contact_no"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("AUTHORITY") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-select
                  id="authority"
                  v-model.trim="$v.managerForm.role_id.$model"
                  :options="paertnerRoles"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
                <show-errors
                  :control="$v.managerForm.role_id"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="text-center">
              <b-button
                class="btn btn-secondary formTextSizeBlack mr-2"
                to="/userList"
                >{{ $t("CANCEL") }}</b-button
              >
              <button class="btn btn-primary formTextSizeBlack" type="submit">
                {{ $t("ADDTO") }}
              </button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import {
  CREATE_PARTNER_USER,
  PARTNER_ROLES,
  EDIT_PARTNER_USER_STATUS,
  GET_PARTNER_USER
} from "@/store/actions.type";
import ShowErrors from "@/components/ShowErrors";
import {
  required,
  email,
  minLength
} from "vuelidate/lib/validators";
import {
  CONSTANTS,
  isNumberValidatorphone,
  phoneDigitValidation
} from "@/shared/utils";
import { preventSpecialChar } from "@/shared/utils.js";

export default {
  name: "createUser",
  components: {
    ShowErrors
  },

  data: function() {
    return {
      preventSpecialChar: preventSpecialChar,
      isNumberValidatorphone: isNumberValidatorphone,
      phoneDigitValidation: phoneDigitValidation,
      CONSTANTS: null,
      FormTitle: "",
      max: 10,
      /* manager form model */
      managerForm: {
        last_name: "",
        first_name: "",
        email: "",
        contact_no: "",
        role_id: null,
        managerForm: ""
      },
      paertnerRoles: [],
      managercreateObj: {
        category: ""
      }
    };
  },
  /*validation for the Each fields in From */
  validations: {
    managerForm: {
      last_name: { required },
      first_name: { required },
      email: { required, email },
      contact_no: { required, phoneNumber: minLength(10) },
      role_id: { required }
    }
  },
  methods: {
    redirect() {
      this.$router.push({
        name: "userlist"
      });
    },
    /**
     * Sumbitting the Filled Form
     * Input @param {object} object this.userForm object which is filled by the user / in Edit also Using the same function
     * Output @param {boolean}   response Boolean status Api call (true =  success, false = failed)
     */
    async submitForm(evt) {
      this.$v.$touch();
      if (!this.$v.managerForm.$invalid) {
        if (phoneDigitValidation(this.managerForm.contact_no) === true) {
          this.$toast.error({
            message: this.$t("INVALIDPHONENO")
          });
          return;
        }
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        let formData = this.managerForm;
        if (_.get(this.params, "id", 0)) {
          formData["id"] = this.params.id;
          let response = await this.$store.dispatch(
            EDIT_PARTNER_USER_STATUS,
            formData
          );

          this.isLoading.hide();
          if (_.get(response, "status", false)) {
            this.$toast.success({
              message: _.get(response, "message", "")
            });
            this.$router.push({
              name: "userlist"
            });
          } else {
            this.$toast.error({
              message: _.get(response, "message", "")
            });
          }
        } else {
          let response = await this.$store.dispatch(
            CREATE_PARTNER_USER,
            formData
          );
          this.isLoading.hide();
          if (_.get(response, "status", false)) {
            this.$toast.success({
              message: _.get(response, "message", "")
            });
            this.$router.push({
              name: "userlist"
            });
          } else {
            this.$toast.error({
              message: _.get(response, "message", "")
            });
          }
        }
      }
    },

    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  async created() {
    this.CONSTANTS = CONSTANTS;
    this.FormTitle = "CREATE";
    await this.$store.dispatch(PARTNER_ROLES).then(data => {
      this.paertnerRoles = data.roles;
    });
    this.params = this.$route.params;
    if (_.get(this.params, "id", 0)) {
      /* if param id exist call edit API else create API */
      this.FormTitle = "EDIT";
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let data = await this.$store.dispatch(GET_PARTNER_USER, {
        id: _.get(this.params, "id", 0)
      });
      this.isLoading.hide();
      if (_.get(data, "status", 0)) {
        this.managerForm = {
          first_name: _.get(data, "partner.first_name", ""),
          last_name: _.get(data, "partner.last_name", ""),
          email: _.get(data, "partner.email", ""),
          contact_no: _.get(data, "partner.contact_no", ""),
          role_id: _.get(data, "partner.role.id", ""),
          userid: _.get(data, "partner.user.userid", "")
        };
      }
    }
  }
};
</script>
<style scoped>
.dragArea {
  min-height: 100px;
  background: #ededed;
  padding: 10px;
}
.list-group-item {
  margin-bottom: 6px;
}
</style>
